"use client"

import { defineRecipe } from "@chakra-ui/react"

const linkRecipe = defineRecipe({
  variants: {
    variant: {
      primary: {
        color: "primary",
        fontWeight: "bold",
        textDecoration: "none",
        borderBottom: "0px solid",
        borderRadius: "0px",
        _hover: {
          color: "#39AED2",
          borderColor: "#39AED2",
          textDecoration: "underline",
        },
        _disabled: {
          borderBottom: "none",
          cursor: "unset",
          color: "primary !important",
          fontWeight: "normal",
        },
      },
      secondary: {
        color: "primary",
        fontWeight: "semibold",
        borderBottom: "0px solid",
        borderRadius: "0px",
        textDecoration: "none",
        _hover: {
          color: "#39AED2",
          borderColor: "#39AED2",
          textDecoration: "underline",
        },
        _disabled: {
          borderBottom: "none",
          cursor: "unset",
          color: "primary !important",
          fontWeight: "normal",
        },
      },
    },
  },
})

export default linkRecipe
